import { FilterDropdown } from "@repo/ui";

import { DropDownProps } from ".";

interface Props extends DropDownProps {}

export function ChannelsDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="channelIds"
			allOption
			values={props.options?.data ?? []}
			objectName="Channels"
			fullLength
			isMulti
		/>
	);
}
